export default __webpack_public_path__ + "static/media/Bitmap(1).0638481f.png";